<template>
<div>
  <HorizontalTopbarInside />
    <b-row class="row">
      <AppBreadcrumb />
      <b-col md="6">
        <div class="select w-75">
          <b-form-select
              v-model="form.region_id"
              :options="regions"
              text-field="nameuz"
              value-field="id"
              @input="fetchRayons"
              class="form-select d-flex"
              aria-label="Default select example"></b-form-select>
          <b-form-select
              v-model="form.rayon_id"
              :options="rayons"
              text-field="nameuz"
              value-field="id"
              @input="fetchSchools"
              class="form-select d-flex mt-3"
              aria-label="Default select example"></b-form-select>
          <label class="mt-2">{{$t('message.Schools')}}</label>
          <b-form-select
              v-model="form.school_id"
              :options="schools"
              text-field="organizationfullname"
              value-field="organizationid"
              class="form-select d-flex mb-3"
              aria-label="Default select example"></b-form-select>
        </div>
      </b-col>
      <b-col md="6">
        <div class="select w-75">
          <b-form-select
              v-model="form.position_level_id"
              :options="position_level"
              text-field="name_uz"
              value-field="id"
              class="form-select d-flex"
              aria-label="Default select example"></b-form-select>
          <b-form-select
              v-model="form.position_id"
              :options="positions"
              text-field="name_uz"
              value-field="id"
              class="form-select d-flex mt-3"
              aria-label="Default select example"></b-form-select>
          <div class="mt-2 d-flex justify-content-end">
            <div class="d-inline-flex mt-4">
              <b-button variant="warning" size="lg" @click="fetchAllJobs" style="margin-right: 20px; width: 150px">
                <div style="color: #185d89">
                {{$t('message.Search')}}
                </div>
              </b-button>
              <b-button size="lg" class="me-2" @click="resetFilter" style="width: 150px; background-color: #185d89" >
                {{$t('message.Clear')}}
              </b-button>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div>
      <b-card class="mt-4">
      <b-table
          striped
          hover
          class="w-100"
          :items="vacancy_applications"
          :fields="fields"
          responsive
      >
        <template #cell(id)="data">
          <span class="text-md text-primary"> {{ (data.index + 1) }}</span>
        </template>
        <template #cell(vacancy_count)="{item}">
          <span>{{item.vacancy_count - item.accepted_applications_count}}</span>
        </template>
        <template #cell(action)="data">
          <div class="d-flex">
<!--            <b-button-->
<!--                class="sm"-->
<!--                size="sm"-->
<!--                style="width: 40px;-->
<!--                height: 36px;-->
<!--                margin-right: 10px;-->
<!--                background-color: #185d89"-->
<!--                @click="pushRoute(data.item.id)"-->
<!--            ><i class='bx bx-show bx-xs'></i>-->
<!--            </b-button>-->
            <div>
              <b-button
                  variant="primary"
                  size="sm"
                  style="width: 140px; height: 36px;
                   margin-right: 10px;
                   background-color: #185d89"
                  @click="pushRoute(data.item.id)"
              >
                {{$t('message.Apply')}}
              </b-button>
            </div>
          </div>
        </template>
      </b-table>
        <div class="d-flex justify-content-end mt-3">
          <b-pagination
              v-model="pagination.page"
              hide-goto-end-buttons
              :total-rows="total"
              :per-page="pagination.pageSize"
              @input="fetchAllJobs()"
          />
        </div>
      </b-card>
    </div>
</div>
</template>

<script>

import {getSchoolJobVacancy} from "../../../../api/school_job_vacancy";
import {getRayons, getRegions} from "../../../../api/regions";
import {getSchools} from "../../../../api/schools";
import {getPositionLevels, getPositions} from "../../../../api/directories";
import HorizontalTopbarInside from "../../../../components/horizontal-topbar-inside";
import AppBreadcrumb from "../../../layouts/AppBreadcrumb";

export default {
  name: "VacancyIndex",
  components:{
    AppBreadcrumb,
    HorizontalTopbarInside,
  },
  data() {
    return {
      selected: null,
      regions:[],
      rayons:[{id:null,nameuz:this.$t('message.Rayon')}],
      schools:[],
      position_level:[{id:null,name:this.$t('message.Position_level')}],
      positions:[{id:null,name:this.$t('message.Positions')}],
      total:1,
      pagination:{
        page:1,
        pageSize: 20,
      },
      fields: [
        {
          key:'id',
          label: this.$t('message.Id')
        },
        {
          key:'position.name',
          label: this.$t('message.Positions')
        },
        // {
        //   key:'education.name',
        //   label: this.$t('message.Education')
        // },
        {
          key:"salary",
          label: this.$t('message.Salary')
        },
        {
          key:"work_experience.name",
          label: this.$t('message.Work_experience')
        },
        {
          key:"vacancy_count",
          label: this.$t('message.Vacancy_count')
        },
        {
          key:"privileges",
          label: this.$t('message.Privileges')
        },
        // {
        //   key:'updated_at',
        //   label: 'Updated at'
        // },
        {
          key:"deadline",
          label: this.$t('message.Deadline')
        },
        {
          key:"action",
          label: this.$t('message.Action')
        }
      ],
      form:{
        region_id : null,
        rayon_id : null,
        school_id : null,
        position_level_id : null,
        position_id : null,
      },
      vacancy_applications: [],
    }
  },
  created() {
    this.fetchAllJobs()
    this.fetchRegions()
    this.fetchPositionLevel()
    this.fetchPositions()
  },
  methods:{
    handlePush(id){
      this.$router.push({ name: 'positioninformation',params: {id}})
    },
    pushRoute(id){
      this.$router.push({name:'rankinformation',params: {id}})
    },
    fetchAllJobs(){
      getSchoolJobVacancy({...this.form,...this.pagination}).then(response => {
        this.vacancy_applications = response.data.data.data;
        this.total = response.data.data.total;
      })
    },
    fetchRegions(){
      getRegions().then(response => {
        this.regions = response.data.data
        this.regions.unshift({id:null, nameuz: this.$t('message.Region')})
      })
    },
    fetchRayons(){
      this.form.rayon_id = null
      this.rayons.unshift({id:null, nameuz: this.$t('message.Rayon')})
      getRayons(this.form.region_id).then(response => {
        this.rayons = response.data.data
      })
    },
    fetchSchools(){
      getSchools({oblastid: this.form.region_id , regionid: this.form.rayon_id}).then(response => {
        this.schools = response.data.data
      })
    },
    fetchPositionLevel(){
      getPositionLevels().then(response => {
        this.position_level = response.data.data
        this.position_level.unshift({id:null, name_uz: this.$t('message.Position_level')})
      })
    },
    fetchPositions(){
      getPositions().then(response => {
        this.positions = response.data.data
        this.positions.unshift({id:null, name_uz: this.$t('message.Positions')})
      })
    },
    resetFilter() {
      this.form.rayon_id = null;
      this.form.position_level_id = null;
      this.form.position_id = null
      this.form.region_id = null;
      this.form.school_id = null;
      this.fetchAllJobs()
    },
  },
}
</script>

<style scoped>
.btn{
  border-radius: 15px;
}
.row{
  margin-top: 170px;
  margin-left: 80px
}
</style>
